<template>
  <div class="notification-wrapper">
    <v-navigation-drawer
      stateless
      v-model="showNotificationPanel"
      fixed
      width="500"
      right
    >
      <v-btn
        class="closeButton"
        color="white"
        fab
        @click="showNotificationPanel = false"
      >
        <v-icon>clear</v-icon>
      </v-btn>
      <v-row no-gutters class="pl-3 pr-3" fill-height>
        <v-col>
          <h5 class="headline menuTitle" primary-title>
            {{ $t("sideNotificationMenu.title") }}
          </h5>
          <v-list>
            <div v-for="(notification, i) in unreadNotifications" :key="i">
              <notification-card
                :notification="notification"
                @navigateto="navigateToExternalPage"
              ></notification-card>
            </div>
          </v-list>
          <v-row no-gutters justify="center" class="mt-2">
            <v-btn
              text
              class="button-open-notifications"
              @click="goToNotificationCenter"
              >{{ $t("sideNotificationMenu.goToCenter") }}</v-btn
            >
          </v-row>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    unreadNotifications() {
      return this.$store.getters["notifications/getUnreadNotifications"];
    },
    showNotificationPanel: {
      get() {
        return this.$store.getters["notifications/getShowNotificationPanel"];
      },
      set(value) {
        this.$store.commit("notifications/setShowNotificationPanel", value);
      }
    }
  },
  watch: {
    $route() {
      this.closeNotificationMenu();
    }
  },
  methods: {
    closeNotificationMenu() {
      this.showNotificationPanel = false;
    },
    navigateToExternalPage(memberNotificationType, notificationAppointmentId) {
      this.showNotificationPanel = false;
      if (memberNotificationType === "CEILING") {
        this.$router.push({ name: "copertureMassimali" });
      }
      if (memberNotificationType === "APPOINTMENT") {
        this.$router.push({
          name: "bookingDetails",
          query: { id: notificationAppointmentId }
        });
      }
      if (memberNotificationType === "MEMORANDUM") {
        this.$router.push({
          name: "bookingWizard",
          query: { q: "serviceArea" }
        });
      }
    },
    goToNotificationCenter() {
      this.showNotificationPanel = false;
      this.$router.replace({ name: "centroNotifiche" });
    }
  }
};
</script>

<style scoped>
.v-navigation-drawer {
  z-index: 15;
  contain: unset;
  overflow: visible;
  background-color: var(--secondary) !important;
  box-shadow: rgba(128, 128, 128, 0.68) -4px 0px 6px;
}
.menuTitle {
  font-family: Roboto, sans-serif;
  font-size: 25px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.16;
  letter-spacing: normal;
  color: var(--primary-dark);
  text-align: center;
  padding-top: 9px;
}
.v-list {
  height: calc(100vh - 72px - 40px);
  overflow-y: auto;
}
.closeButton {
  position: absolute;
  background: white;
  width: 50px;
  height: 50px;
  background-color: var(--primary) !important;
  color: white;
  z-index: 2;
  left: 0;
  transform: translateX(-60%);
}
.v-navigation-drawer--close .closeButton {
  display: none;
}
.button-open-notifications {
  border-radius: 6px;
  background-color: var(--primary) !important;
  color: white !important;
}
</style>
